import h from "trader-hyperscript";
import { rpc } from "trader.ts/network";
import { Form, constantField, selectBox, textBox } from "trader.ts/ui.forms";
import { instrumentid, roomid, siteid } from "../../../sql/classy/types";
import * as style from "../../../styles/style.css.classes";
import { checkboxesField } from "../../client/checkboxesfield";
import { renderDeleteButton, renderSaveButton } from "../../client/savebutton";
import * as routes from "../../routes";
import { mandatoryValidation } from "../../lib/validate";

export function render(opts: {
  room: null | {
    id: roomid;
    description: string;
    siteid: siteid;
    instruments:
      | {
          instrumentid: instrumentid;
        }[]
      | null;
  }  ;
  allSites: { id: siteid; description: string }[];
  allInstruments: { id: instrumentid; description: string }[];
}): HTMLElement | HTMLElement[] {
  const room = opts.room;
  const form = new Form({})
    .addField("id", [], () => constantField(room?.id ?? null))
    .addField("description", [], () =>
      textBox({
        initialVal: room?.description || "",
        label: "Naam",
        validations: [mandatoryValidation],
      }),
    )
    .addField("site", [], () => {
      if (opts.allSites.length === 0) {
        throw new Error("No sites");
      } else if (opts.allSites.length === 1) {
        return constantField(opts.allSites[0]);
      } else {
        return selectBox({
          values: opts.allSites,
          initial: room
            ? opts.allSites.find((s) => s.id === room.siteid)!
            : opts.allSites[0],
          show: (s) => s.description,
          label: "Vestiging",
        });
      }
    })
    .addField("instruments", [], async () =>
      checkboxesField({
        values: opts.allInstruments.orderBy((instr) => instr.description),
        initial: room
          ? opts.allInstruments.filter((instr) =>
              (room.instruments || []).some(
                (ri) => ri.instrumentid === instr.id,
              ),
            )
          : opts.allInstruments,
        show: (i) => i.description,
        addNoFilterOption: false,
        addAllOption: true,
      }),
    )
    .build({
      render: (fields) => (
        <div className={style.equal_columns}>
          <div>
            {fields.description()}
            {fields.site()}
          </div>
          <div>
            <div>
              <label for="">{"Cursussen"}</label>
            </div>
            <div
              className={style.panel}
              style="background-color: var(--grey-100); border: none; "
            >
              {fields.instruments()}
            </div>
          </div>
        </div>
      ),
    });
  return (
    <section style="width: 100%">
      <section>{form.render()}</section>
      <div style="text-align: right">
        {room === null ? (
          <span></span>
        ) : (
          renderDeleteButton({
            label: "Verwijder lokaal",
            confirmationLabel: "Ben je zeker dat je dit lokaal wilt verwijderen?",
            doDelete: () =>
              rpc(routes.deleteRoomSpec, undefined, { roomid: room.id }),
            redirectTo: routes.room_listRoute.link(),
          })
        )}
        {renderSaveButton({
          formS: form.s,
          save: (room) =>
            rpc(routes.saveRoomSpec, undefined, {
              id: room.id,
              description: room.description,
              siteid: room.site.id,
              instruments: room.instruments.map((instr) => ({
                instrumentid: instr.id,
              })),
            }).then((res) => {
              if ("tag" in res && res.tag === "success") {
                return {
                  ...res,
                  redirectUrl: routes.roomeditRoute.link({
                    roomid: res.id,
                  }),
                  timeout: 1500,
                };
              }
              return res;
            }),
          timeout: 1500,
          reload: false,
        })}
      </div>
    </section>
  );
}
